module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_2-b4f331197167f067bf5b94ad50cf9505.png";